import React from 'react';
import { Icon } from './Icon.js';
export const IconCheckboxUnchecked = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("rect", { x: "3", y: "3", width: "14", height: "14", rx: "3", ry: "3", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconCheckboxUnchecked.js.map